import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { SimOrderStepper } from 'console/sim/order-sim/stepper';
import { CompareSimTariff } from '../shared/compare-tariff';
export const SimOrderCompare = memo(function SimOrderCompare() {
    return (_jsxs(ErrorBoundary, { children: [_jsx(CompareSimTariff, {}), _jsx(SimOrderStepper, { step_id: 0 })] }));
});
